import React from 'react';

import img from '../images/imagen1.jpeg';
import { Link } from 'react-router-dom';

const Intro = () => {
    return (
        <div id="about" className="bg-gray-100 py-12" >
            <section data-aos="zoom-in-down">
                    <div className="my-0 py-0">
                        <h2 className="my-2 text-center text-4xl text-red-900 uppercase font-bold">ABOUT</h2>
                        
                        <div className='flex justify-center'>
                            <div className='w-24 border-b-4 border-red-900'></div>
                        </div>
                        <h3 className="mt-4 mx-12 text-center text-4xl  text-blue-900 font-bold text-red-900">Quality You Can See. Care You Can Feel.</h3>
                    </div>

                <div className="m-auto max-w-6xl " >

                    <div className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left" data-aos="fade-up">
                        <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                            <img alt="card img" className="rounded-t-2xl float-right float-left" src={img} />
                        </div>
                        <div className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8" data-aos="zoom-in" data-aos-delay="500">
                            
                            <h3 className="text-4xl  text-red-900 font-bold">Redefine Clean — Elevate Your Home with Our Experts.</h3>
                            <div>
                                <p className='my-3 text-xl text-gray-600 font-semibold'>We take pride in caring for your home as if it were our own, offering detailed and personalized cleaning services that suit your lifestyle.</p>
                            </div>

                            <Link to="/contact" className="text-white bg-red-900 hover:bg-red-800 inline-flex items-center justify-center w-full px-6 py-2 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0 group">
                                Contact us
                                <svg className="w-4 h-4 ml-1 group-hover: translate-x-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Intro;